<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
    >
      <path
        id="Icon_material-close"
        data-name="Icon material-close"
        d="M43.5,11.126,39.874,7.5,25.5,21.874,11.126,7.5,7.5,11.126,21.874,25.5,7.5,39.874,11.126,43.5,25.5,29.126,39.874,43.5,43.5,39.874,29.126,25.5Z"
        transform="translate(-7.5 -7.5)"
      />
    </svg>
  </div>
</template>
